import { _ as l } from "./objectWithoutPropertiesLoose-2ffc4b6d.js";
import "./es.object.assign-7e79fd7b.js";
import { c as r } from "./index-8b07dec9.js";
import n, { css as p } from "styled-components";
import { IconButton as c } from "./iconButton.js";
import { jsx as m } from "react/jsx-runtime";
var d = ["active", "disabled"], v = /* @__PURE__ */ n(c).withConfig({
  displayName: "ellipses__EllipsesContainer",
  componentId: "sc-1ctvfq5-0"
})(["&.EllipsesContainer{", ";}"], function(s) {
  var e = s.theme.components.menu;
  return p(e.ellipses.EllipsesContainer);
}), x = function(e) {
  var i = e.active, a = i === void 0 ? !1 : i, o = e.disabled, t = l(e, d);
  return /* @__PURE__ */ m(v, Object.assign({
    className: r(["EllipsesContainer", {
      "EllipsesContainer--active": a
    }, {
      "EllipsesContainer--disabled": o
    }])
  }, t, {
    size: "extra-small",
    color: "black",
    variant: "ghost",
    icon: "moreVertical"
  }));
};
export {
  x as E,
  v as a
};
